import {PanelBankFlowSectionConfig} from './types';

export type PageSizeOption = number | 'all';

const MULTIPLIER = 2;
const MAX_OPTIONS = 6;
const MAX_PAGE_SIZE = 50;

export const getFlowConfigPageSizeOptions = ({
  flowConfig,
  numTotalPanelsInSection,
}: {
  flowConfig: PanelBankFlowSectionConfig;
  numTotalPanelsInSection: number;
}): PageSizeOption[] => {
  const options: PageSizeOption[] = [flowConfig.columnsPerPage];

  let nextSize = flowConfig.columnsPerPage * MULTIPLIER;
  while (
    nextSize < numTotalPanelsInSection &&
    nextSize <= MAX_PAGE_SIZE &&
    options.length < MAX_OPTIONS
  ) {
    options.push(nextSize);
    nextSize *= MULTIPLIER;
  }

  if (numTotalPanelsInSection <= MAX_PAGE_SIZE) {
    options.push('all');
  }

  return options;
};

export const getFlowConfigMaxRowsPerPage = ({
  flowConfig,
  numTotalPanelsInSection,
  option,
}: {
  flowConfig: PanelBankFlowSectionConfig;
  numTotalPanelsInSection: number;
  option: number | 'all';
}) => {
  const totalPanels = Math.min(
    numTotalPanelsInSection,
    option === 'all' ? numTotalPanelsInSection : option
  );
  const newRowsPerPage = Math.ceil(totalPanels / flowConfig.columnsPerPage);

  return Math.ceil(newRowsPerPage);
};
